function noop() {
    /* empty function */
}
export { noop };
//# sourceMappingURL=index.js.map